import { Constants, OrderDetail } from '../../../../../core';
import { statusPicking } from '../../../../../core/configs/statusOfPicking';
import { environment } from '../../../../../../environments/environment';
import { OECHSLE_CODE, PROMART_CODE, SUPERMERCADOS_CODE } from '../../../../../core/configs/company.config';

const iconsOfActionsList = [
  {
    icon: 'locate',
    tooltip: 'Ubicar',
    hasVisibleCondition: (element: OrderDetail[]): boolean => {
      const filters = element.find(item => !item.localizable && (item.status.toUpperCase() !== Constants.statusPicking.canceled && item.status.toUpperCase() !== Constants.statusPicking.returned && item.lpnNumber !== '-'));
      return filters ? false : true;
      // element[0].localizable && element.filter(item => !!item).length === 1;
    }
  },
  {
    icon: 'retirement',
    tooltip: 'Entregar',
    hasVisibleCondition: (element: OrderDetail[]): boolean => {
      const filters = element.find(item => !item.pendingQuantity && !item.deliveredQuantity);
      return !filters ? true : false;
    }
  },
  {
    icon: 'returned',
    tooltip: 'Devolución',
    hasVisibleCondition: (element: OrderDetail[]): boolean => {
      const companyCode = JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code;
      const filters = element.find(item =>
        [Constants.statusPicking.toLocate,
        Constants.statusPicking.warehouse,
        Constants.statusPicking.delivered,
        Constants.statusPicking.canceled].includes(item.status));
      const isOriginSeller = element[0].originType === Constants.OriginType.SELLER;

      return !!filters && (isOriginSeller || element[0].isRedExterna) && companyCode && companyCode != OECHSLE_CODE && companyCode != PROMART_CODE && companyCode != SUPERMERCADOS_CODE;
    }
  },
  {
    icon: 'returned_seller',
    tooltip: 'Devolución a Seller',
    hasVisibleCondition: (element: OrderDetail[]): boolean => {
      const companyCode = JSON.parse(localStorage.getItem(environment.sessionAuth)).user.entity.company.code;
      const filters = element.find(item => item.status === Constants.statusPicking.returned);
      const isOriginSeller = element[0].originType === Constants.OriginType.SELLER;
      return !!filters && isOriginSeller && !element[0].isRedExterna && companyCode && companyCode != OECHSLE_CODE && companyCode != PROMART_CODE && companyCode != SUPERMERCADOS_CODE;
    }
  },
  {
    icon: 'returned_origin',
    tooltip: 'Devolución a Origen',
    hasVisibleCondition: (element: OrderDetail[]): boolean => {
      const filters = element.find(item => item.status === Constants.statusPicking.returned);
      return !!filters && element[0].isRedExterna;
    }
  },
  {
    icon: 'printer',
    tooltip: 'Reimprimir entrega',
    hasVisibleCondition: (element: OrderDetail[]): boolean => {
      const filters = element.find(item => item.status.includes('ENTREGADO')); // === Constants.statusPicking.delivered);
      return !filters ? false : element.length === 1 ? true : false;
    }
  }
];
export const inStorePickingDetail = {
  searchText: '',
  addText: '',
  checkbox: true,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '', // item.status === Constants.statusPicking.delivered
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (item: any) => {
    if (item.isRedExterna) {
      return (item.status !== Constants.statusPicking.toLocate && item.status !== Constants.statusPicking.warehouse
        && item.status !== Constants.statusPicking.delivered && item.status !== Constants.statusPicking.returned);
    } else {
      return (item.status === Constants.statusPicking.toArrive
        || (!item.localizable && (!(item.status.includes('ENTREGADO') || item.status.includes('DEVOLUCION'))) &&
          (item.status.toUpperCase() !== Constants.statusPicking.canceled && item.lpnNumber !== '-')) || item.lpnNumber === '-');
    }
  },

  classValidation: (row: any) => {
    if ((row.status && row.status.toUpperCase() === Constants.statusPicking.canceled)
      || (parseFloat(row.canceledQuantity) === parseFloat(row.quantity) && parseFloat(row.canceledQuantity) !== 0)
      || (parseFloat(row.canceledQuantity) === parseFloat(row.pendingQuantity) && parseFloat(row.quantity) === 0 && parseFloat(row.canceledQuantity) > 0)) {
      return 'pending';
    }
    return '';
  },

  show: 'No existe despacho registrado para el cliente',
  columns: [
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: OrderDetail) => element.skuCode
    },
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: OrderDetail) => element.description.replace('�', '')
    },
    {
      title: 'LPN',
      name: 'lpnNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: OrderDetail) => element.lpnNumber
    },
    {
      title: 'Cant. Recibida',
      name: 'quantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderDetail) => element.quantity
    },
    {
      title: 'Cant. Pendiente de entrega',
      name: 'pendingQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderDetail) => element.pendingQuantity
    },
    {
      title: 'Cant. Entregada',
      name: 'deliveredQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderDetail) => element.deliveredQuantity
    },
    {
      title: 'Cant. Cancelada',
      name: 'canceledQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderDetail) => element.canceledQuantity
    },
    {
      title: 'Cant. Devuelta',
      name: 'returnedQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderDetail) => element.returnedQuantity
    },
    {
      title: 'Estado',
      name: 'status',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: OrderDetail) => element.status.toUpperCase()
    },
    {
      title: 'Ubicación',
      name: 'location',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderDetail) => element.location ? element.location
        : (element.locationLpn
          && (element.status.toUpperCase() === statusPicking.warehouse || element.status.toUpperCase() === statusPicking.delivered
            || element.status.toUpperCase() === statusPicking.deliveredPending)
          ? element.locationLpn : '')
    },
    {
      title: 'Detalles',
      name: 'details',
      type: 'button',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: OrderDetail) => {
        return {
          data: element.details,
          icon: 'playlist_add_check',
          tooltip: 'Ver detalles',
          class: ' recordColumn icon-table'
        };
      }
    }
  ]
};
